
import Vue from 'vue';
import axios from 'axios';
import {mapState} from 'vuex';
import EventService from '../services/EventService';
import moment from 'moment';

type News = {
  Summary: string;
  Detail: string;
  IsNew: boolean;
  CreatedAt: string;
};

type Data = {
  NewsList: Array<News>;
};

type Headers = {
  Authorization: string;
  'x-company-id'?: string;
};

type Config = {
  withCredentials: boolean;
  headers: Headers;
};

export default Vue.extend({
  computed: {
    ...mapState(['user', 'current']),
  },
  async mounted() {
    const token = await this.user?.getIdToken();
    const config: Config = {
      withCredentials: true,
      headers: {Authorization: `Bearer ${token}`},
    };
    const companyID = this.current;
    if (companyID !== '') {
      config.headers['x-company-id'] = companyID;
    }
    config.headers;
    const {data} = await axios.put(
      `${EventService.ProtoURL()}/news/`,
      {},
      config
    );
    console.log(data);
    this.NewsList = data.map((val: News) => {
      return {
        Summary: val.Summary,
        Detail: val.Detail,
        IsNew: true,
        CreatedAt: val.CreatedAt,
      };
    });
    this.$store.dispatch('news');
    console.log(this.NewsList);
  },
  methods: {
    displayTime: (val: string): string => {
      const updateAt = moment(val);
      return updateAt.format('YYYY/MM/DD');
    },
  },
  data: (): Data => ({
    NewsList: [],
  }),
});
